import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import HelpCenterTwoToneIcon from '@mui/icons-material/HelpCenterTwoTone';
import React from "react";
import { delayedRedirect } from "./helpers";
import { useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import { jobStatuses } from "../../../../../statuses";

const name = "Booking";

interface BookingProps {
    jobId: number;
    statusId: number;
    date: Date;
}

const fixDate = (date: Date) => {
    return new Date(date).toLocaleString("en-GB").replace(/\/[0-9]{4}./g, "");
}

const Booking: React.FC<BookingProps> = ({ jobId, statusId, date }) => {
    const navigate = useNavigate();

    const newDate = fixDate(date);

    return (
        (<ListItem component="button" key={jobId} sx={{ p: 0, maxWidth: "19.5rem", }} >
            <ListItemIcon sx={{ minWidth: "2rem", minHeight: "1rem", }} >
                <HelpCenterTwoToneIcon color='warning' />
            </ListItemIcon>
            <ListItemText
                onClick={() => delayedRedirect(navigate, "/booking-form", jobId)}
                primary={`${jobId} - ${jobStatuses[String(statusId) as keyof typeof jobStatuses].replace("In ", "")} ${newDate}`}
                slotProps={{
                    primary: { fontSize: "0.9rem", }
                }} />
        </ListItem>)
    );
}

Booking.displayName = name;

export default React.memo(Booking);